enum ChatEvents {
  messageReceived = 'messageReceived',
  participantAddedToChat = 'participantAddedToChat',
  participantRemovedFromChat = 'participantRemovedFromChat'
};

export default ChatEvents;
